import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Col, Dropdown } from 'react-bootstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { useDispatch, useSelector } from 'react-redux';
import { storeShipper, storeShipperGroup } from '../stores/slice';
import ShipmentStatus from './../data/shipment-status.json';
import { Link } from 'react-router-dom';
import awsconfig from "../aws-exports";
import boxStatus from "../data/box-status.json";
import Select from 'react-select';
import { API } from 'aws-amplify';
const style = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
        ...base,
        minHeight: '28px',
        height: '28px',
        border: 'none', // Changed from '0px' to 'none',
        borderRadius: '8px',
        boxShadow: 'none' // Added to remove any box shadow
    }),
    valueContainer: (base) => ({
        ...base,
        height: '28px',
        padding: '0 4px',
        fontSize: "14px",
        fontWeight: "semi-bold",
        minWidth: "80px",
        background: "#EDF2F9",
        border: 'none'
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: '28px',
        background: "#EDF2F9",
        border: 'none'
    })
};


export const TableShipperGroupMultiFilter = ({ dark, onChange }) => {
    const dispatch = useDispatch();
    const color = dark ? 'btn-dark' : 'btn-light';
    const myShipperGroup = useSelector((state) => state.slice.SHIPPER_GROUP);
    const myShipperGroups = useSelector((state) => state.slice.SHIPPER_GROUPS);

    const options = myShipperGroups.map((item) => ({
        value: item.shipperGroup.id,
        label: item.shipperGroup.name,
    }));

    const handleChange = (selectedOptions) => {
        const selectedShipperGroups = selectedOptions.map(option => myShipperGroups.find(group => group.shipperGroup.id === option.value));
        dispatch(storeShipperGroup(selectedShipperGroups));
    };

    return (
        <>
            {myShipperGroups?.length > 0 && (
                <Col className='col-auto px-1 my-1'>
                    <Select
                        isMulti
                        styles={style}
                        isClearable
                        options={options}
                        className={`basic-multi-select ${color}`}
                        classNamePrefix="select"
                        onChange={handleChange}
                        placeholder={`Client: ${myShipperGroup?.shipperGroup?.name || 'All'}`}
                    />
                </Col>
            )}
        </>
    );
};



export const TableShipperMultiFilter = ({ dark, hideAll, onChange }) => {
    const dispatch = useDispatch();

    const color = dark ? 'btn-dark' : 'btn-light';
    const myShipper = useSelector((state) => state.slice.SHIPPER);
    const myShippers = useSelector((state) => state.slice.SHIPPERS);

    const options = myShippers.map((item) => ({
        value: item.shipper.id,
        label: item.shipper.name,
    }));

    const handleChange = (selectedOptions) => {
        onChange(selectedOptions)
    };

    return (
        <Col className='col-auto px-1 my-1'>
            <Select
                isMulti
                isClearable
                options={options}
                styles={style}
                className={`basic-multi-select ${color}`}
                classNamePrefix="select"
                onChange={handleChange}
                placeholder={`Location: ${myShipper?.shipper?.name || 'All'}`}
            />
        </Col>
    );
};

export const UserCarrierMultiFilter = ({ value, onChange, carrierList, dark }) => {
    const color = dark ? 'btn-dark' : 'btn-light';

    const options = carrierList.map((item) => ({
        value: item.id,
        label: item.name,
    }));

    const handleChange = (selectedOptions) => {
        onChange(selectedOptions.map(option => carrierList.find(carrier => carrier.id === option.value)));
    };

    return (
        <Col className='col-auto px-1 my-1'>
            <Select
                isMulti
                options={options}
                styles={style}
                isClearable
                className={`basic-multi-select ${color}`}
                classNamePrefix="select"
                onChange={handleChange}
                placeholder={`Courier: ${value?.name || 'All'}`}
            />
        </Col>
    );
};

export const DriverMultiFilter = ({ value, onChange, shipper, carrier }) => {
    const [driverList, setDriverList] = useState([]);

    const search = async (keyword) => {
        const apiName = "api";
        const path = `/search/user?size=1000`;
        const init = {
            body: {
                sort: {
                    "name.keyword": {
                        "order": "asc"
                    }
                },
                query: {
                    bool: {
                        filter: [
                            {
                                term: {
                                    "carriers.carrier.name.keyword": carrier?.name
                                }
                            }
                        ]
                    }
                }
            },
        };
        if (keyword) {
            init.body.query.bool.must = [{
                multi_match: {
                    query: keyword,
                    type: "phrase_prefix",
                    fields: ["name", "alias"]
                }
            }];
        }
        const { hits } = await API.post(apiName, path, init);
        let sourceData = hits?.hits?.length > 0 ? hits.hits.map((item) => item._source) : [];
        sourceData.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'accent' }));
        let items = [];
        sourceData.forEach((item) => {
            items.push({
                name: item.name,
                id: item.id,
            });
        });
        setDriverList(items);
    };

    useEffect(() => {
        search();
        onChange(null);
    }, [shipper, carrier]);

    const options = driverList.map((item) => ({
        value: item.id,
        label: item.name,
    }));

    const handleChange = (selectedOptions) => {
        onChange(selectedOptions ? selectedOptions.map(option => driverList.find(driver => driver.id === option.value)) : []);
    };

    return (
        <Col className='col-auto px-1 my-1 col'>
            <Select
                isMulti
                options={options}
                styles={style}
                isClearable
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={handleChange}
                value={value?.length ? value.map((item) => {
                    return { label: item.name, value: item.id }
                }) : null}
                placeholder={`Driver: ${value?.name || "All"}`}
            />
        </Col>
    );
};


export const ServiceTypeMultiFilter = ({ value, onChange, serviceList, carrierId }) => {
    const newServiceList = serviceList.filter((item) => item.carrierId === carrierId) || serviceList;

    const options = newServiceList.map((item) => ({
        value: item.id,
        label: item.name,
    }));

    const handleChange = (selectedOptions) => {
        onChange(selectedOptions ? selectedOptions.map(option => newServiceList.find(service => service.id === option.value)) : []);
    };

    return (
        <Col className='col-auto px-1 my-1 col'>
            <Select
                isMulti
                options={options}
                styles={style}
                isClearable
                className="basic-multi-select"
                classNamePrefix="select"
                value={value?.length ? value.map((item) => {
                    return { label: item.name, value: item.id }
                }) : null}
                onChange={handleChange}
                placeholder={`Service: ${value?.name || "All"}`}
            />
        </Col>
    );
};


export const StatusMultiFilter = ({ value, dark, onChange }) => {
    const color = dark ? 'btn-dark' : 'btn-light';

    const statusOptions = [
        { label: 'Ready for Pickup', value: 'READY_FOR_PICKUP' },
        { label: 'Out for Delivery', value: 'OUT_FOR_DELIVERY' },
        { label: 'Delivered', value: 'DELIVERED' },
        { label: 'In Transit', value: 'IN_TRANSIT' },
        { label: 'Out for Return', value: 'OUT_FOR_RETURN' },
        { label: 'Returned', value: 'RETURNED' },
        { label: 'Cancelled', value: 'EXCEPTION' },
        { label: 'Open', value: 'OPEN' },
        { label: 'Lost', value: 'LOST' }
    ];

    const handleChange = (selectedOptions) => {
        onChange(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };

    return (
        <Col className='col-auto px-1 my-1'>
            <Select
                isMulti
                options={statusOptions}
                styles={style}
                isClearable
                value={value?.length ? value.map((item) => {
                    return { label: item, value: item }
                }) : null}
                className={`basic-multi-select ${color}`}
                classNamePrefix="select"
                onChange={handleChange}
                placeholder={`Status: ${value?.join(', ') || 'All'}`}
            />
        </Col>
    );
};


export const GreenPhoxMultiFilter = ({ value, onChange, dark }) => {
    const color = dark ? 'btn-dark' : 'btn-light';

    const options = [
        { label: 'GreenPhox', value: true },
        { label: 'Other', value: false },
    ];

    const handleChange = (selectedOptions) => {
        onChange(selectedOptions ? selectedOptions.map(option => option) : []);
    };

    return (
        <Col className='col-auto px-1 my-1'>
            <Select
                isMulti
                options={options}
                styles={style}
                isClearable
                className={`basic-multi-select ${color}`}
                classNamePrefix="select"
                onChange={handleChange}
                placeholder={`Box Type: ${value?.map(v => v.label).join(', ') || 'All'}`}
            />
        </Col>
    );
};



